import axios from "axios"
import React, { Component } from "react"
import Loader from "src/components/common/Loader"
import AxiosConfig from "src/utilities/AxiosConfig"
import VehicleMaintenance from "../../Overview/Maintenance/VehicleMaintenance"
import "./MaintenanceApprovalDecoupler.css"

interface Props {
    userId: string | number
    VehicleInformationId: string
    VehicleMaintenanceId: string
    setCompleted?: Function
}

interface State {
    fleetReference: any
    info: any
    maintenances: Array<any> | null
}

class MaintenanceApprovalDecoupler extends Component<Props, State> {

    opened = false

    state = {
        fleetReference: null,
        info: null,
        maintenances: null,
    }

    componentDidMount() {
        this.getFleetReference()
        this.getVehicleInfo()
        this.getVehicleMaintenances()
    }

    getFleetReference = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/reference", AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ fleetReference: res.data })
            }).catch(err => {
                //console.log(err)
            })
    }

    getVehicleInfo = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/getVehicleByVehicleInformationId/" + this.props.VehicleInformationId + "", AxiosConfig.configValue())
            .then(res => {
                this.setState({ info: res.data })
                // this.getProfitCenterDescription(res.data)
                // this.getVehicleStatusDescription(res.data)
            }).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }


    getVehicleMaintenances = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/getMaintenancesByVehicleId/" + this.props.VehicleInformationId + "", AxiosConfig.configValue())
            .then(res => {
                this.setState({ maintenances: res.data })
            }).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    findMaintenance = (maintenances: Array<any> | null) => {
        if (maintenances) {
            for (let i = 0; i < maintenances.length; i++) {
                if (maintenances[i].VehicleMaintenanceId.toString() === this.props.VehicleMaintenanceId) {
                    return i
                }
            }
        }
        return null
    }

    simulateCardClick = (cardDex: number) => {
        let elem = document.getElementById("vm-toggle-" + cardDex)
        if (elem && !this.opened) {
            elem.click()
            this.opened = true
            setTimeout(() =>{
                if(elem){
                    elem.scrollIntoView()
                }
            },1000)
        } else {
            setTimeout(() => {
                this.simulateCardClick(cardDex)
            }, 500)
        }
    }

    render() {

        const props = this.props
        const state = this.state
        const cardDex: number | null = this.findMaintenance(state.maintenances)
        const ready = state.info && state.maintenances && state.fleetReference && props.userId && cardDex

        if (ready && cardDex) {
            this.simulateCardClick(cardDex)
        }

        return (
            <div className="MaintenanceApprovalDecoupler">
                {ready && <VehicleMaintenance
                    details={state.info}
                    maintenances={state.maintenances}
                    fleetReference={state.fleetReference}
                    userId={props.userId}
                    refreshAll={() => null}
                    updateNotiication={props.setCompleted}
                />}
                {!ready && <div className="MaintenanceApprovalDecouplerLoading">
                    <span className="material-icons">build</span>
                    <Loader title="Loading Maintenance record" />
                </div>}
            </div>
        )
    }
}

export default MaintenanceApprovalDecoupler;